import { render, staticRenderFns } from "./ScrollText.vue?vue&type=template&id=36171528&scoped=true&"
import script from "./ScrollText.vue?vue&type=script&lang=js&"
export * from "./ScrollText.vue?vue&type=script&lang=js&"
import style0 from "./ScrollText.vue?vue&type=style&index=0&id=36171528&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36171528",
  null
  
)

export default component.exports